<p-toast></p-toast>

<p-table selectionMode="single" [value]="quotations">
  <ng-template pTemplate="header">
    <tr>
      <th>ID</th>
      <th>Description</th>
      <th>Total</th>
      <th>Currency</th>
      <th>Created</th>
      <th>Created By</th>
      <th>Actions</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-quotation>
    <tr [pSelectableRow]="quotation">
      <td>
        {{quotation.id}}
      </td>
      <td>
        {{quotation.description}}
      </td>
      <td>
        {{quotation.totalInBaseCurrency}}
      </td>
      <td>
        {{quotation.baseCurrency.isoCode}}
      </td>
      <td>
        {{quotation.created | date: 'dd/MM/yyyy'}}
      </td>
      <td>
        <span>
          {{quotation.createdBy.name}}
        </span>
      </td>
      <td>
        <p-button icon="pi pi-file-pdf" pTooltip="Download PDF" tooltipPosition="top"
          (onClick)="downloadReport(quotation)"></p-button>
        <p-button icon="pi pi-envelope" pTooltip="Send by Email" tooltipPosition="top"
          (onClick)="createEmailForm(quotation)"></p-button>
        <p-button icon="pi pi-clone" pTooltip="Clone this quotation" tooltipPosition="top"
          (onClick)="cloneQuotation(quotation)"></p-button>
        <p-button icon="pi pi-trash" pTooltip="Delete this quotation" tooltipPosition="top"
          (onClick)="deleteQuotation(quotation)" styleClass="p-button-danger"></p-button>
      </td>
    </tr>
  </ng-template>
</p-table>
<p-dialog header="Send this document by email" [modal]="true" [(visible)]="displayEmailForm" (onHide)="resetEmailForms()">
  <div [formGroup]="bookingQuotationEmailForm" class="email-form-container" *ngIf="bookingQuotationEmailForm">
    Send email to: {{student.email}}
    <span>Subject: <input formControlName="subject"></span>
    <textarea rows="30" cols="100" formControlName="body"></textarea>
    <div>
      <p-button label="Send" (onClick)="sendQuotationByEmail()"></p-button>
      <span>
        attachment: File name here
      </span>
    </div>
  </div>
</p-dialog>

<p class="global-title">From Lead</p>
<p-table selectionMode="single" [value]="contactRequestQuotations">
  <ng-template pTemplate="header">
    <tr>
      <th>ID</th>
      <th>Description</th>
      <th>Total</th>
      <th>Currency</th>
      <th>Created</th>
      <th>Created By</th>
      <th>Actions</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-contactRequestQuotation>
    <tr [pSelectableRow]="contactRequestQuotation">
      <td>
        {{contactRequestQuotation.id}}
      </td>
      <td>
        {{contactRequestQuotation.description}}
      </td>
      <td>
        {{contactRequestQuotation.totalInBaseCurrency}}
      </td>
      <td>
        {{contactRequestQuotation.baseCurrency.isoCode}}
      </td>
      <td>
        {{contactRequestQuotation.created | date: 'dd/MM/yyyy'}}
      </td>
      <td>
        <span>
          {{contactRequestQuotation.createdBy.name}}
        </span>
      </td>
      <td>
        <p-button icon="pi pi-file-pdf" pTooltip="Download PDF" tooltipPosition="top"
          (onClick)="downloadContactRequestQuotation(contactRequestQuotation)"></p-button>
        <p-button icon="pi pi-envelope" pTooltip="Send by Email" tooltipPosition="top"
          (onClick)="createContactRequestQuotationEmailForm(contactRequestQuotation)"></p-button>
        <p-button icon="pi pi-clone" pTooltip="Clone this quotation" tooltipPosition="top"
          (onClick)="cloneContactRequestQuotation(contactRequestQuotation)"></p-button>
        <p-button icon="pi pi-trash" pTooltip="Delete this quotation" tooltipPosition="top"
          (onClick)="deleteContactRequestQuotation(contactRequestQuotation)" styleClass="p-button-danger"></p-button>
      </td>
    </tr>
  </ng-template>
</p-table>
<p-dialog header="Send this document by email" [modal]="true" [(visible)]="displayContactRequestQuotationEmailForm"
  (onHide)="resetEmailForms()">
  <div [formGroup]="contactRequestQuotationEmailForm" class="email-form-container"
    *ngIf="contactRequestQuotationEmailForm">
    Send email to: {{student.email}}
    <span>Subject: <input formControlName="subject"></span>
    <textarea rows="30" cols="100" formControlName="body"></textarea>
    <div>
      <p-button label="Send" (onClick)="sendContactRequestQuotationByEmail()"></p-button>
      <span>
        attachment: File name here
      </span>
    </div>
  </div>
</p-dialog>